export default "__VITE_ASSET__UaTb$_Zz__"